export default __webpack_public_path__ + "static/media/2066.66cc2a5d.png";